import moment from "moment";

export function fromNow(date) {
  if (date) return moment(normalize(date)).fromNow();
  else return "";
}

export function normalize(date) {
  if (date && typeof date === "string" && !date.includes(":"))
    return parseInt(date);
  else return date;
}

export function fromJson(jsonDate) {
  var offset = new Date().getTimezoneOffset();
  var parts = /\/Date\((-?\d+)([+-]\d{2})?(\d{2})?.*/.exec(jsonDate);

  if (parts[2] == undefined) parts[2] = 0;

  if (parts[3] == undefined) parts[3] = 0;

  return new Date(+parts[1] + offset + parts[2] * 3600000 + parts[3] * 60000);
}

export function toReadable(date) {
  if (date) {
    date = convert(normalize(date));
    return date.toLocaleDateString([], {
      //weekday: "narrow",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
  }

  return "";
}

export function toReadableDate(date) {
  if (date && date != "") {
    date = convert(normalize(date));
    return date.toLocaleDateString();
  }

  return "";
}

export function convert(dateStr) {
  if (dateStr) {
    const dateObj = new Date(dateStr);
    return dateObj;
  }

  return null;
}

export function duration(date1, date2) {
  const start = moment(date1);
  const end = moment(date2);
  const duration = end.diff(start, "minutes", true);
  return +(Math.round(duration + "e+2") + "e-2");
}
